'use client';

import { Box } from '@mantine/core';
import classnames from './statistics.module.css';

export function StatisticsList({ children }: { children: React.ReactNode }) {
  return <Box className={classnames.news}>{children}</Box>;
}
